






































import Vue from 'vue';
import { getFeatureFlag } from '@/services/FeatureFlagService';

export default Vue.extend({
  props: ['feature', 'onClick'],
  data() {
    return {
      item: getFeatureFlag(this.feature),
    };
  },
  watch: {
    '$store.state.featureFlag.featureFlags'() {
      this.item = getFeatureFlag(this.feature);
    },
  },
});
